import { sub } from 'date-fns';
import * as Yup from 'yup';

export const validationSchema = (minDateStartedJob) => {
  return Yup.object({
    firstName: Yup.string('Enter your first name')
      .max(50, 'Max. 50 characters')
      .required('First name is required')
      .matches(/^[a-zA-ZÀ-ÿ -\s']+$/, "Not numbers allowed")
      .typeError(`First name can't be empty`),
    lastName: Yup.string('Enter your last name')
      .max(50, 'Max. 50 characters')
      .required('Last name is required')
      .matches(/^[a-zA-ZÀ-ÿ -\s']+$/, "Not numbers allowed")
      .typeError(`Last name can't be empty`),
    middleName: Yup.string()
      .max(50, 'Max. 50 characters')
      .matches(/^[a-zA-ZÀ-ÿ -\s']+$/, "Not numbers allowed")
      .nullable(),
    phoneNumber: Yup.string().notRequired().nullable(),
    address: Yup.string().notRequired().nullable(),
    state: Yup.string().notRequired().nullable(),
    county: Yup.string().notRequired().nullable(),
    city: Yup.string().notRequired().nullable(),
    otherCounty: Yup.string().notRequired().nullable(),
    otherCity: Yup.string().notRequired().nullable(),
    manualCity: Yup.string().notRequired().nullable(),
    email: Yup.string('Enter the employee Email')
      .email('Invalid email')
      .max(50, 'Max. 50 characters')
      .required('Email is required')
      .typeError(`Email can't be empty`),
    zipCode: Yup.string('Enter your ZIP Code')
      .matches(/^\d+$/, 'zip code must be only numbers')
      .max(5, 'zip code must be only 5 digits')
      .min(5, 'zip code must be 5 digits')
      .notRequired()
      .nullable(),
    socialNumber: Yup.string()
      .min(11, 'Please complete the SSN')
      .max(11, 'Please complete the SSN')
      .notRequired()
      .nullable(),
    jobPosition: Yup.string().notRequired().nullable(),
    hourlyStartWage: Yup.string().notRequired().nullable(),
    dateBirth: Yup.date('Invalid date, "MM/dd/yyyy" format')
      .max(sub(new Date(), { days: 1 }), 'Invalid date')
      .test('is-more-than-16', 'Employee must be at least 16 years old', (value) => {
        return sub(new Date(), { years: 16 }) > value;
      })
      .notRequired()
      .nullable()
      .typeError('Invalid date, "MM/dd/yyyy" format'),
    occupationCode: Yup.string().notRequired().nullable(),
    dateGaveInfo: Yup.date().nullable().notRequired(),
    externalEmployeeId: Yup.string().nullable().notRequired(),
    dateStartedJob: Yup.date()
      .nullable()
      .notRequired()
      .min(minDateStartedJob, 'The date cannot be less than the date of hire or the date the job was offered.')
      .typeError('Invalid date, "MM/dd/yyyy" format'),
    dateWasHired: Yup.date()
      .nullable()
      .notRequired()
      .typeError('Invalid date, "MM/dd/yyyy" format'),
    dateWasOfferedJob: Yup.date()
      .nullable()
      .notRequired()
      .typeError('Invalid date, "MM/dd/yyyy" format'),
    isOtherCounty: Yup.string().nullable().notRequired(),
  });
}
